import React, { useEffect } from 'react';
import { Drawer } from '@gjensidige/core-drawer';
import { text } from '../../../utils/text';
import { Text, Title } from '@gjensidige/core-typography';
import style from './personvern-info-modal.module.less';
import { setBodyOverflow } from '../../../utils/view';
import { Action } from '../../../utils/types';
import { useGlobalContext } from '../../../context/GlobalContext';
export const PersonvernInfoModal = () => {
    const [{ personvernModal }, dispatch] = useGlobalContext();
    const close = () => {
        dispatch({
            type: Action.SHOW_PERSONVERN_MODAL,
            state: { show: false },
        });
    };
    useEffect(() => {
        setBodyOverflow(personvernModal.show);
    }, [personvernModal.show]);
    return (React.createElement(Drawer, { closable: true, visible: personvernModal.show, onClick: close, ariaLabel: text.PERSONVERN_INFO_MODAL.ARIA_LABEL.no, ariaLabelCloseButton: text.PERSONVERN_INFO_MODAL.ARIA_LABEL_CLOSE.no, className: style.personvernModal, strict: false },
        React.createElement("section", null,
            React.createElement(Title, { tag: "h1", size: "h2" }, text.PERSONVERN_INFO_MODAL.MODAL.TITLE.no),
            React.createElement(Text, { size: "lead" }, text.PERSONVERN_INFO_MODAL.MODAL.SUBTITLE.no)),
        React.createElement("section", null,
            React.createElement(Title, { tag: "h2", size: "h4" }, text.PERSONVERN_INFO_MODAL.MODAL.WHAT.TITLE.no),
            React.createElement(Text, null, text.PERSONVERN_INFO_MODAL.MODAL.WHAT.CONTENT.no)),
        React.createElement("section", null,
            React.createElement(Title, { tag: "h2", size: "h4" }, text.PERSONVERN_INFO_MODAL.MODAL.RIGHTS.TITLE.no)),
        React.createElement("section", null,
            React.createElement(Title, { tag: "h2", size: "h4" }, text.PERSONVERN_INFO_MODAL.MODAL.RIGHTS.INNSYN.TITLE.no),
            React.createElement(Text, null, text.PERSONVERN_INFO_MODAL.MODAL.RIGHTS.INNSYN.CONTENT.no)),
        React.createElement("section", null,
            React.createElement(Title, { tag: "h2", size: "h4" }, text.PERSONVERN_INFO_MODAL.MODAL.RIGHTS.KORRIGERING.TITLE.no),
            React.createElement(Text, null, text.PERSONVERN_INFO_MODAL.MODAL.RIGHTS.KORRIGERING.CONTENT.no)),
        React.createElement("section", null,
            React.createElement(Title, { tag: "h2", size: "h4" }, text.PERSONVERN_INFO_MODAL.MODAL.RIGHTS.SLETTING.TITLE.no),
            React.createElement(Text, { className: style.noMargin }, text.PERSONVERN_INFO_MODAL.MODAL.RIGHTS.SLETTING.CONTENT.no),
            React.createElement("ul", null, text.PERSONVERN_INFO_MODAL.MODAL.RIGHTS.SLETTING.LIST_ITEMS.no)),
        React.createElement("section", null,
            React.createElement(Text, null, text.PERSONVERN_INFO_MODAL.MODAL.FOOTER.no))));
};
